"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var Ant = __importStar(require("antd"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var OpenInNew_1 = require("@styled-icons/material/OpenInNew");
var RichTextEditor_1 = __importDefault(require("../RichTextEditor"));
var ImageModal_1 = __importDefault(require("../RichTextEditor/ImageModal"));
var ArticleEditorUtil_1 = require("./ArticleEditorUtil");
function ArticleEditor(props, ref) {
  var _this = this;
  var user = reconnect_js_1.useOutlet('user')[0];
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var _a = props.collection,
    collection = _a === void 0 ? {} : _a,
    document = props.document,
    // undifined = create
    _b = props.options,
    // undifined = create
    options = _b === void 0 ? {} : _b,
    _c = props.onUpdate,
    onUpdate = _c === void 0 ? function () {} : _c,
    _d = props.onClose,
    onClose = _d === void 0 ? function () {} : _d,
    _e = props.onPreview,
    onPreview = _e === void 0 ? function () {
      window.alert('沒有提供預覽方式');
    } : _e,
    _f = props.token,
    token = _f === void 0 ? '' : _f,
    _g = props.showMetaField,
    showMetaField = _g === void 0 ? true : _g,
    _h = props.hideSubmitButton,
    hideSubmitButton = _h === void 0 ? false : _h;
  var _j = collection.name,
    collectionName = _j === void 0 ? 'Article_Default' : _j,
    _k = collection.primary_key,
    primaryKey = _k === void 0 ? 'id' : _k;
  var _l = react_1.default.useState(),
    content = _l[0],
    setContent = _l[1];
  var _m = react_1.default.useState({}),
    values = _m[0],
    setValues = _m[1];
  var _o = react_1.default.useState(false),
    hide = _o[0],
    setHidden = _o[1];
  var _p = react_1.default.useState(false),
    showDialog = _p[0],
    setShowDialog = _p[1];
  react_1.useEffect(function () {
    // intial
    if (props.document) {
      var _a = props.document || {},
        _id = _a._id,
        id = _a.id,
        created = _a.created,
        updated = _a.updated,
        content_1 = _a.content,
        values_1 = __rest(_a, ["_id", "id", "created", "updated", "content"]);
      setContent(content_1);
      setValues(values_1);
    }
  }, [props.document]);
  var _setValues = react_1.default.useCallback(function (obj) {
    setValues(function (preValues) {
      return __assign(__assign({}, preValues), obj);
    });
  }, []);
  if (ref) {
    ref.current = {
      getDocument: function getDocument() {
        return __awaiter(_this, void 0, void 0, function () {
          var _a;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _a = {
                  content: content
                };
                return [4 /*yield*/, ArticleEditorUtil_1.generateHtml(content)];
              case 1:
                return [2 /*return*/, (_a.html = _b.sent(), _a)];
            }
          });
        });
      }
    };
  }
  return react_1.default.createElement(react_1.default.Fragment, null, showMetaField && !hide && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(InputField, {
    label: "\u6A19\u984C",
    value: values.title,
    row: true,
    placeholder: "\u6A19\u984C",
    onChange: function onChange(e) {
      var value = e.target.value;
      _setValues({
        title: value
      });
    }
  }), react_1.default.createElement(Row, null, react_1.default.createElement("label", {
    style: {
      color: 'gray',
      marginBottom: 8
    }
  }, "\u6A19\u7C64\uFF08\u9078\u586B\uFF09"), react_1.default.createElement(ArrayInput, {
    value: values.label,
    onChange: function onChange(value) {
      _setValues({
        label: value
      });
    }
  })), react_1.default.createElement(Row, null, react_1.default.createElement(InputField, {
    label: "\u4F5C\u8005\uFF08\u9078\u586B\uFF09",
    value: values.author,
    row: true,
    placeholder: "",
    onChange: function onChange(e) {
      var value = e.target.value;
      _setValues({
        author: value
      });
    }
  }), react_1.default.createElement(Row, {
    style: {
      marginBottom: 8
    }
  }, react_1.default.createElement("label", {
    style: {
      color: 'gray'
    }
  }, "\u5716\u7247\uFF08\u9078\u586B\uFF09"), react_1.default.createElement("div", {
    style: {
      width: 150,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }
  }, values.image || '尚未選擇'), react_1.default.createElement(Ant.Button, {
    onClick: function onClick() {
      return setShowDialog(true);
    }
  }, "\u9078\u64C7")), react_1.default.createElement(InputField, {
    label: "\u7248\u672C",
    value: values.version,
    row: true,
    placeholder: "v0.0.1",
    onChange: function onChange(e) {
      var value = e.target.value;
      _setValues({
        version: value
      });
    }
  }), document && user && react_1.default.createElement(Ant.Button, {
    onClick: function onClick() {
      return onPreview(document);
    },
    // href={`/article?id=${id}&client=${user.client}`}
    // target="_blank"
    style: {
      marginBottom: 8
    }
  }, react_1.default.createElement(OpenInNew_1.OpenInNew, {
    color: "black",
    size: 16
  }))), react_1.default.createElement(Row, null, react_1.default.createElement("label", {
    style: {
      color: 'gray',
      marginRight: 8
    }
  }, "\u5927\u7DB1"), react_1.default.createElement("textarea", {
    rows: 3,
    value: values.outline,
    onChange: function onChange(e) {
      var value = e.target.value;
      _setValues({
        outline: value
      });
    },
    style: {
      border: 'solid 1px #d9d9d9',
      padding: 3,
      flex: 1
    }
  }))), showMetaField && react_1.default.createElement(Row, null, react_1.default.createElement(CollapseDivider, null), react_1.default.createElement(CollapseButton, {
    onClick: function onClick() {
      return setHidden(!hide);
    }
  }, hide ? '▼' : '▲'), react_1.default.createElement(CollapseDivider, {
    style: {
      flex: '0 0 60px'
    }
  })), react_1.default.createElement(RichTextEditor_1.default, {
    options: options,
    token: token,
    onChange: function onChange(value) {
      return setContent(value);
    },
    content: content
  }), react_1.default.createElement("div", {
    style: {
      backgroundColor: '#ccc',
      width: '100%',
      height: 1,
      margin: '10px 0'
    }
  }), react_1.default.createElement(Row, null, document && react_1.default.createElement("div", {
    style: {
      color: '#aaa',
      fontSize: 12
    }
  }, "\u5EFA\u7ACB ", new Date(document.created).toLocaleString('sv')), document && react_1.default.createElement("div", {
    style: {
      color: '#aaa',
      fontSize: 12,
      margin: '0 10px'
    }
  }, "/"), document && react_1.default.createElement("div", {
    style: {
      color: '#aaa',
      fontSize: 12
    }
  }, "\u66F4\u65B0 ", new Date(document.updated).toLocaleString('sv')), document && react_1.default.createElement("div", {
    style: {
      color: '#aaa',
      fontSize: 12,
      margin: '0 10px'
    }
  }, "/"), document && react_1.default.createElement("div", {
    style: {
      color: '#aaa',
      fontSize: 12
    }
  }, document.id), react_1.default.createElement("div", {
    style: {
      flex: 1
    }
  }), !hideSubmitButton && react_1.default.createElement(Ant.Button, {
    type: "primary",
    onClick: function onClick() {
      return __awaiter(_this, void 0, void 0, function () {
        var record, _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              record = __assign({}, values);
              _a = record;
              return [4 /*yield*/, ArticleEditorUtil_1.generateHtml(content)];
            case 1:
              _a.html = _b.sent();
              return [4 /*yield*/, ArticleEditorUtil_1.upsertArticle(record, document, {
                collectionName: collectionName,
                primaryKey: primaryKey,
                token: token,
                onUpdate: onUpdate,
                onClose: onClose
              })];
            case 2:
              _b.sent();
              return [2 /*return*/];
          }
        });
      });
    }
  }, document ? '編輯' : '建立')), react_1.default.createElement(ImageModal_1.default, {
    visible: showDialog,
    url: values.image,
    onCancel: function onCancel() {
      return setShowDialog(false);
    },
    onInsert: function onInsert(url) {
      return _setValues({
        image: url
      });
    },
    token: token
  }));
}
var Row = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var CollapseDivider = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 1px;\n  flex: 1;\n  background-color: #eee;\n"], ["\n  height: 1px;\n  flex: 1;\n  background-color: #eee;\n"])));
var CollapseButton = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  padding: 0px 30px;\n"], ["\n  cursor: pointer;\n  padding: 0px 30px;\n"])));
function InputField(props) {
  var label = props.label,
    children = props.children,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    _b = props.row,
    row = _b === void 0 ? false : _b,
    inputProps = __rest(props, ["label", "children", "style", "row"]);
  var defaultStyle = row ? {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8
  } : {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    marginBottom: 8
  };
  return react_1.default.createElement("div", {
    style: __assign(__assign({}, defaultStyle), style)
  }, react_1.default.createElement("label", {
    style: {
      display: 'block',
      color: 'gray',
      marginRight: 10,
      flexShrink: 0
    }
  }, label), children ? children : react_1.default.createElement(Ant.Input, __assign({}, inputProps)));
}
function ArrayInput(props) {
  var _a = props.style,
    style = _a === void 0 ? {} : _a,
    onChange = props.onChange,
    placeholder = props.placeholder;
  var _b = react_1.default.useState(Array.isArray(props.value) ? props.value : []),
    values = _b[0],
    setValues = _b[1];
  var _c = react_1.default.useState(''),
    input = _c[0],
    setInput = _c[1];
  var onEnter = react_1.default.useCallback(function (e) {
    if (e.key === 'Enter' && input) {
      var _values = __spreadArray(__spreadArray([], values), [input]);
      setValues(_values);
      onChange(_values);
      setTimeout(function () {
        // workaround enter fast then onchange
        setInput('');
      }, 100);
    }
  }, [input, values, onChange]);
  return react_1.default.createElement(ArrayInputWrapper, {
    style: style
  }, values.map(function (v, idx) {
    return react_1.default.createElement(Ant.Tag, {
      key: v,
      closable: true,
      onClose: function onClose(e) {
        var _values = __spreadArray([], values);
        _values.splice(idx, 1);
        setValues(_values);
        onChange(_values);
      }
    }, v);
  }), react_1.default.createElement("input", {
    value: input,
    onChange: function onChange(e) {
      return setInput(e.target.value);
    },
    onKeyDown: onEnter,
    placeholder: placeholder || '按Enter新增標籤'
  }));
}
var ArrayInputWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  border: solid 1px #d9d9d9;\n  padding: 3px;\n  margin-bottom: 8px;\n  & > input {\n    flex: 1 0 50px;\n    border: 0;\n    outline: none;\n  }\n"], ["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  border: solid 1px #d9d9d9;\n  padding: 3px;\n  margin-bottom: 8px;\n  & > input {\n    flex: 1 0 50px;\n    border: 0;\n    outline: none;\n  }\n"])));
exports.default = react_1.default.forwardRef(ArticleEditor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;